import { useEffect, useRef, useState } from "react";
import H2 from "@/atoms/text/H2";
import IntegrationCards from "@/molecules/IntegrationCards";
import SearchBar from "@/molecules/SearchBar";
import Sidebar from "@/molecules/Sidebar";

export default function IntegrationSection() {
  const inputRef = useRef(null);
  const [filterId, setFilterId] = useState("all");
  const [filterValue, setFilterValue] = useState("");
  const [resetSidebar, setResetSidebar] = useState(false);
  const [isSidebarResetting, setIsSidebarResetting] = useState(false);
  const sidebarData = [
    { name: "All Integrations", categoryId: "all" },
    { name: "Popular", categoryId: "popular" },
    { name: "Field service software", categoryId: "field-service" },
    { name: "Home service software", categoryId: "home-service" },
    { name: "Business apps", categoryId: "business" },
    { name: "Customer service", categoryId: "customer-service" },
    { name: "CRM", categoryId: "crm" },
    { name: "Scheduling", categoryId: "scheduling" },
    { name: "Service desk", categoryId: "service-desk" },
  ];

  const categoryFilter = (filterId) => {
    setFilterId(filterId);
    setFilterValue("");
  };

  const searchFilter = (value) => {
    setFilterValue(value);
    if (isSidebarResetting) {
      setIsSidebarResetting(false);
    }
  };

  const resetFilter = (resetValue) => {
    categoryFilter(resetValue);
    setResetSidebar(true);
  };

  useEffect(() => {
    if (resetSidebar) {
      setIsSidebarResetting(true);
      setResetSidebar(false);
    }
  }, [resetSidebar]);

  const handleSidebarReset = () => {
    setIsSidebarResetting(false);
  };

  return (
    <section className="bc-white pv-15-d pv-8">
      <div className="container">
        <div className="fx-d fx--sb mb-8-d mb-5">
          <H2 className="ta-center ta-left-d mb-6 mb-reset-d bold">
            Explore our integrations<span className="dot">.</span>
          </H2>
          <SearchBar
            onSearchValue={searchFilter}
            label="Search for integration"
            placeholder="Try “ServiceTitan”"
            ref={inputRef}
          />
        </div>
        <div className="fx-d fx--ns">
          <Sidebar
            onReset={handleSidebarReset}
            onCategoryFilter={categoryFilter}
            data={sidebarData}
            isResetting={isSidebarResetting}
          />
          <IntegrationCards
            onReset={resetFilter}
            filterId={filterId}
            filterValue={filterValue}
          />
        </div>
      </div>
    </section>
  );
}
